import { useCallback } from "react";
import { useFormContext } from "react-hook-form";
import type { PriceCallout } from "@circle-react/types/PaywallCustomization";
import { PricingTabPriceListCellPricing } from "../../../PricingTab/StripePricingTab/PriceList/CellPricing";
import { localeRoot } from "../../constants";
import { CalloutTextField } from "./Fields/CalloutTextField";
import { HighlightRow } from "./Fields/HighlightRow";

interface PriceCalloutFormProps {
  index: number;
  onClick: (index: number, isHighlighted: boolean) => void;
  priceCallout: PriceCallout;
}

export const PriceCalloutForm = ({
  priceCallout,
  index,
  onClick,
}: PriceCalloutFormProps) => {
  const { watch } = useFormContext();
  const stripePrices = watch("stripe_prices_attributes");

  const findPaywallPrice: any = useCallback(
    () =>
      stripePrices.find((price: any) =>
        [price.id, price.tmp_id].includes(priceCallout.price_id),
      ),
    [stripePrices, priceCallout?.price_id],
  );

  const paywallPrice = findPaywallPrice();
  if (!paywallPrice) {
    return null;
  }

  return (
    <div>
      <HighlightRow index={index} onClick={onClick} />
      <CalloutTextField
        name={`paywall_customization_attributes.price_callout_properties.prices.${index}.callout_text`}
        translationRoot={[localeRoot, "builder.price_callouts.fields"].join(
          ".",
        )}
        label={
          <PricingTabPriceListCellPricing
            row={{ original: paywallPrice }}
            options={{
              shouldShowCurrency: false,
            }}
          />
        }
        formClassName="!p-0"
      />
    </div>
  );
};
